import { useId } from 'react';

import { Box, Mask, Text } from '@farmersdog/corgi-x';

import { Picture } from '../../../components/Picture';

import styles from './ReviewCard.css';

export interface ReviewCardProps {
  sources: string[];
  alt: string;
  quote: string;
  author: string;
}

export function ReviewCard({ sources, alt, quote, author }: ReviewCardProps) {
  const id = useId();

  return (
    <Box as="figure" aria-labelledby={id} className={styles.card}>
      <Mask className={styles.mask} shape="circle" size="md">
        <Picture
          width="72"
          height="72"
          className={styles.image}
          alt={alt}
          sources={sources}
        />
      </Mask>
      <Text variant="article-20" as="span" color="charcoal-3">
        <blockquote className={styles.blockquote}>“{quote}”</blockquote>
        <figcaption id={id} className={styles.caption}>
          <cite className={styles.cite}>— {author}</cite>
        </figcaption>
      </Text>
    </Box>
  );
}
